import { useEffect, useRef, useState } from 'react';

import { COPIED_STATE_DURATION_MS } from '../config';

export const useCopyReferralMessage = (message: string) => {
  const [isCopied, setIsCopied] = useState(false);

  const resetTimerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(
    () => () => {
      clearTimeout(resetTimerRef.current);
    },
    [],
  );

  useEffect(() => {
    clearTimeout(resetTimerRef.current);
    setIsCopied(false);
  }, [message]);

  const copyMessage = async (): Promise<boolean> => {
    try {
      await navigator.clipboard.writeText(message);
    } catch {
      setIsCopied(false);

      return false;
    }

    clearTimeout(resetTimerRef.current);
    setIsCopied(true);
    resetTimerRef.current = setTimeout(
      () => setIsCopied(false),
      COPIED_STATE_DURATION_MS,
    );

    return true;
  };

  return { isCopied, copyMessage };
};
